export default __webpack_public_path__ + "static/persons-modal-dark-mode-b35084cc9429f9180afe488fc097b98a.png";